import TitlePreamble from './titlePreamble.js';
export default TitlePreamble;
